import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { SafetyConfigService } from '../../services/safety-config.service';
import { SafetyLeavesService } from '../../services/safety-leaves.service';
import { LeavesStatusVM, NewLeaveInfo } from '../../entities/global/model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-update-leave-status',
  templateUrl: './update-leave-status.component.html',
  styleUrls: ['./update-leave-status.component.scss']
})

export class UpdateLeaveStatusComponent implements OnInit {
  title:string;

  leavesStatusList:LeavesStatusVM[]= []

  selectedLeaveStatus:number;
  LeaveInfo:NewLeaveInfo;

  LeaveReqId:number=0;
  FilePreview:string;
  Extension:string;
  NewFileName:string;
  Notes:string
  constructor(public dialogRef: MatDialogRef<UpdateLeaveStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _dialog: MatDialog,
    private _notify: NotificationsService,
    private _safetyConfigService: SafetyConfigService,
    private _safetyLeaves :SafetyLeavesService) { }

  ngOnInit() {
    this.title = this.data.title;
    this.loadLeavesStatus();
    
      this.LeaveInfo = this.data.LeaveInfo;
      this.LeaveReqId = this.LeaveInfo.Id;
      this.selectedLeaveStatus = this.LeaveInfo.StatusId;
      this.LoadLeaveAttachedDocument();

  }

  LoadLeaveAttachedDocument(){
    const params = new NewLeaveInfo();
    params.Id =this.LeaveReqId;
    this._safetyLeaves.LoadLeaveAttacheDoc(params).subscribe(res=>{
this.Extension = res.Extention;
this.FilePreview = res.Attachment;
this.Notes=res.Note;
    })
  }
  loadLeavesStatus(){
    this._safetyLeaves.GetAllLeavesStatus().subscribe(res=>{
   
      this.leavesStatusList =res;
        this.selectedLeaveStatus = this.LeaveInfo.StatusId;
    })
  }

  DialogClose(): void {
    this.dialogRef.close(false);
  }


  onClickDownloadForm() {
this.NewFileName = "Attached Document";
    var newstring = this.FilePreview.slice(1);
    console.log('length ', newstring.length - 1)

    let _newstring = newstring.substring(0, newstring.length - 1);
    console.log("newstringnewstringnewstring", _newstring)

    var arrBuffer = this.base64ToArrayBuffer(this.FilePreview);

    if(this.Extension =='pdf'){
      var blob = new Blob([arrBuffer], { type: 'application/pdf' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.pdf';
      link.click();
    }
    else if(this.Extension =='xls'){
      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.xls';
      link.click();
    }
    else if(this.Extension =='docx'){
      var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.docx';
      link.click();
    }
    else if(this.Extension =='png'){
      var blob = new Blob([arrBuffer], { type: 'image/png' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.png';
      link.click();
    }

    else if(this.Extension =='jpg'){
      var blob = new Blob([arrBuffer], { type: 'image/jpg' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.jpg';
      link.click();
    }

    else if(this.Extension =='txt'){
      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });  
      var link = document.createElement('a');    
      link.href = window.URL.createObjectURL(blob);
      link.download = this.NewFileName + '.txt';
      link.click();
    }
}


base64ToArrayBuffer(base64) {
  console.log("base64", base64)
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

  UpdateLeaveStatus(){
    const params = new NewLeaveInfo();
    params.StatusId=this.selectedLeaveStatus;
    params.Id =this.LeaveReqId;
    this._safetyLeaves.UpdateLeaveStatus(params).subscribe(res=>{
      if(res==true){
        this._notify.success("Status Updated Successfully")
        this.dialogRef.close(true);
      }else{
        this._notify.error("Unable to Update Leave Status")
      }
    })

  }

}